import { Box } from "@dealer-center/core-components";
import { type ComponentType, type ReactNode, useState } from "react";

export interface ListComponentProps {
  onSelect: (id: string) => void;
  selectedId: string | null;
}

export interface DetailComponentProps {
  selectedId: string | null;
}

interface Props {
  DetailComponent: ComponentType<DetailComponentProps>;
  emptyState?: ReactNode;
  ListComponent: ComponentType<ListComponentProps>;
}

export const MasterDetailLayout = ({
  DetailComponent,
  emptyState = null,
  ListComponent
}: Props) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(100vh - 115px)",
        overflow: "hidden",
        position: "fixed",
        top: "115px",
        width: "100%"
      }}
    >
      <Box
        sx={{
          borderRight: "1px solid",
          borderColor: "divider",
          flexShrink: 0,
          height: "100%",
          overflowY: "auto",
          width: "300px"
        }}
      >
        <ListComponent selectedId={selectedId} onSelect={setSelectedId} />
      </Box>
      <Box sx={{ flex: 1, height: "100%", overflowY: "auto" }}>
        {selectedId ? <DetailComponent selectedId={selectedId} /> : emptyState}
      </Box>
    </Box>
  );
};
